module.exports = __webpack_public_path__ + "img/Vento.9e9d8af5.svg";